export default "__VITE_ASSET__DssDxl_x__"